import { render } from "./expertOverview.vue?vue&type=template&id=5068f260&scoped=true&ts=true"
import script from "./expertOverview.vue?vue&type=script&lang=ts"
export * from "./expertOverview.vue?vue&type=script&lang=ts"

import "./expertOverview.vue?vue&type=style&index=0&id=5068f260&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5068f260"]])

export default __exports__